import AbsSection from './AbsSection';
import Util from '../common/Util.js';

export default class SecTopBanner extends AbsSection {
    constructor(_container='', _dataM={}, _option={}){

        _option.showArea = (_option.showArea && Util.getCookie('nctvTopBanner') != '1');
        super(_container, _dataM, _option, 'topBanner');
    }

    setTemplate(){
        let bannerData = this.option;
        let tmpl = $(`
<a href="${bannerData.link}" ${bannerData.newWindow? 'target="_blank"': ''} class="banner-link" rel="noopener" style="background-image: url('${bannerData.image?bannerData.image:''}')">
    <span class="banner-text">${bannerData.title}</span>
</a>
<a href="#close" class="banner-close">${require('../../svg/close.svg')}</a>`);

        $( this.container ).css({'background-color':bannerData.bgColor});
        tmpl.find('em').css({'color':bannerData.textEmColor});

        $( this.container + ' .banner-inner' ).html( tmpl );
        TweenMax.fromTo(this.container, 0.5, {opacity:0}, {opacity:1});
    }
    
    setEvents(){
        $( this.container + ' .banner-close' ).on('click', e=>{
            $(this.container).hide();
            Util.setCookie('nctvTopBanner', '1', 1);
            return false;
        });
        
    }
} // end of class